var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',_vm._g(_vm._b({staticClass:"app-button",class:{
    'app-button-medium': _vm.$props.buttonSize === 'medium',
    'without-borders': !_vm.$props.borders
  }},'a-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }